import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { type CurrencyModel } from '@root/entities/currency'
import { useTranslation } from '@root/shared/localization'

import { PremiumListItemButton } from '../common/premium-list-item-button'

import type { CurrencyWithPremium } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium/atoms'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel
  onExtend?: (currency: CurrencyWithPremium.CurrencyWithPremium) => void
}

export const ActivePremiumListItemRenew: React.FC<Props> = ({
  currency,
  premium,
  onExtend,
}) => {
  const { t } = useTranslation()

  const [allowedToExtend] = useAtom(premium.isAllowedToExtend)

  return (
    <Root
      variant="soft"
      radius="rounded"
      disabled={!allowedToExtend}
      onClick={(e) => {
        e.stopPropagation()
        onExtend?.({ currency, premium })
      }}
    >
      {t('premium.button.renew-premium')}
    </Root>
  )
}

export const Root = styled(PremiumListItemButton)`
  color: var(--warningAccent-10);

  &:hover:not(:disabled) {
    color: var(--warningAccent-10);
  }
`
